export const esNumero = (numero: any) => typeof numero === "number";
